/* tslint:disable */
/* eslint-disable */
/**
 * Risks API
 * API for managing risks.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BorrowerPricingWithGuaranteeDto } from './BorrowerPricingWithGuaranteeDto';
import {
    BorrowerPricingWithGuaranteeDtoFromJSON,
    BorrowerPricingWithGuaranteeDtoFromJSONTyped,
    BorrowerPricingWithGuaranteeDtoToJSON,
    BorrowerPricingWithGuaranteeDtoToJSONTyped,
} from './BorrowerPricingWithGuaranteeDto';
import type { BorrowerCardStatuses } from './BorrowerCardStatuses';
import {
    BorrowerCardStatusesFromJSON,
    BorrowerCardStatusesFromJSONTyped,
    BorrowerCardStatusesToJSON,
    BorrowerCardStatusesToJSONTyped,
} from './BorrowerCardStatuses';
import type { BorrowerQuoteTabDto } from './BorrowerQuoteTabDto';
import {
    BorrowerQuoteTabDtoFromJSON,
    BorrowerQuoteTabDtoFromJSONTyped,
    BorrowerQuoteTabDtoToJSON,
    BorrowerQuoteTabDtoToJSONTyped,
} from './BorrowerQuoteTabDto';
import type { BorrowerProcessDto } from './BorrowerProcessDto';
import {
    BorrowerProcessDtoFromJSON,
    BorrowerProcessDtoFromJSONTyped,
    BorrowerProcessDtoToJSON,
    BorrowerProcessDtoToJSONTyped,
} from './BorrowerProcessDto';
import type { BorrowerDisabledReasons } from './BorrowerDisabledReasons';
import {
    BorrowerDisabledReasonsFromJSON,
    BorrowerDisabledReasonsFromJSONTyped,
    BorrowerDisabledReasonsToJSON,
    BorrowerDisabledReasonsToJSONTyped,
} from './BorrowerDisabledReasons';
import type { ContractInsured } from './ContractInsured';
import {
    ContractInsuredFromJSON,
    ContractInsuredFromJSONTyped,
    ContractInsuredToJSON,
    ContractInsuredToJSONTyped,
} from './ContractInsured';
import type { BorrowerContractualizationPricingDto } from './BorrowerContractualizationPricingDto';
import {
    BorrowerContractualizationPricingDtoFromJSON,
    BorrowerContractualizationPricingDtoFromJSONTyped,
    BorrowerContractualizationPricingDtoToJSON,
    BorrowerContractualizationPricingDtoToJSONTyped,
} from './BorrowerContractualizationPricingDto';
import type { BorrowerDocumentDto } from './BorrowerDocumentDto';
import {
    BorrowerDocumentDtoFromJSON,
    BorrowerDocumentDtoFromJSONTyped,
    BorrowerDocumentDtoToJSON,
    BorrowerDocumentDtoToJSONTyped,
} from './BorrowerDocumentDto';
import type { BorrowerPermissions } from './BorrowerPermissions';
import {
    BorrowerPermissionsFromJSON,
    BorrowerPermissionsFromJSONTyped,
    BorrowerPermissionsToJSON,
    BorrowerPermissionsToJSONTyped,
} from './BorrowerPermissions';

/**
 * 
 * @export
 * @interface BorrowerContractualizationResponse
 */
export interface BorrowerContractualizationResponse {
    /**
     * Type discriminator (EMP)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    $type?: string;
    /**
     * Type de contractualisation (EMP)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    quoteId: string;
    /**
     * Unique identifier of the tunnel/funnel
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    tunnelId: string;
    /**
     * Human-readable folder identifier (optional)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    folderIdentifier?: string;
    /**
     * 
     * @type {ContractInsured}
     * @memberof BorrowerContractualizationResponse
     */
    insured: ContractInsured;
    /**
     * Numéro de l'emprunteur (1 pour principal, 2+ pour co-emprunteurs)
     * @type {number}
     * @memberof BorrowerContractualizationResponse
     */
    borrowerNumber: number;
    /**
     * Indique si les informations de risque sont complètes
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isCompletedRiskInformation: boolean;
    /**
     * Code statut brut (E, AC, RCL, etc.)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    statusCode: string;
    /**
     * Catégorie du statut de la quote
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    statusCategory: BorrowerContractualizationResponseStatusCategoryEnum;
    /**
     * Sévérité du statut pour l'affichage UI
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    statusSeverity: BorrowerContractualizationResponseStatusSeverityEnum;
    /**
     * Statut de signature du contrat
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    contractSignatureStatus: BorrowerContractualizationResponseContractSignatureStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isContractStepStarted: boolean;
    /**
     * Indique si c'est un cas Lemoine (dispense questionnaire médical)
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isCasLemoine: boolean;
    /**
     * Indique si le mandat SEPA est signé
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isMandateSigned: boolean;
    /**
     * Indique si c'est l'emprunteur principal
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isMaster: boolean;
    /**
     * Indique si l'animation UI est terminée
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isAnimationCompleted: boolean;
    /**
     * Indique si le contrat a été envoyé
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isContractSend: boolean;
    /**
     * Indique si le certificat d'adhésion existe
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    hasCertificate: boolean;
    /**
     * Indique si les conditions particulières sont complètes (mandat, date d'effet, périodicité, type projet)
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isConditionsComplete: boolean;
    /**
     * Indique si un bien immobilier est rattaché au projet d'emprunt
     * @type {boolean}
     * @memberof BorrowerContractualizationResponse
     */
    isRealEstateComplete?: boolean;
    /**
     * Code du type de projet emprunteur (RESIDENCE_PRINCIPALE, ACHAT_LOCATIF, etc.)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    projectTypeCode?: string | null;
    /**
     * Date d'effet prévisionnelle de l'assurance (date de début du projet d'emprunt) — absente tant qu'elle n'est pas renseignée
     * @type {Date}
     * @memberof BorrowerContractualizationResponse
     */
    expectedEffectiveDate?: Date | null;
    /**
     * Identifiant du bien immobilier rattaché au projet d'emprunt (null si non défini)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    realEstateId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    productOwner: string;
    /**
     * 
     * @type {BorrowerContractualizationPricingDto}
     * @memberof BorrowerContractualizationResponse
     */
    pricing?: BorrowerContractualizationPricingDto;
    /**
     * 
     * @type {Array<BorrowerPricingWithGuaranteeDto>}
     * @memberof BorrowerContractualizationResponse
     */
    pricingLoans: Array<BorrowerPricingWithGuaranteeDto>;
    /**
     * 
     * @type {Array<BorrowerQuoteTabDto>}
     * @memberof BorrowerContractualizationResponse
     */
    quoteTabs: Array<BorrowerQuoteTabDto>;
    /**
     * Code de la grille médicale (ex "FM4"). Pilote l'affichage de la carte Fiche médicale.
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    medicalGridCode?: string | null;
    /**
     * Liste des noms de documents médicaux requis
     * @type {Array<string>}
     * @memberof BorrowerContractualizationResponse
     */
    medicalDocuments: Array<string>;
    /**
     * 
     * @type {Array<BorrowerDocumentDto>}
     * @memberof BorrowerContractualizationResponse
     */
    documents?: Array<BorrowerDocumentDto>;
    /**
     * 
     * @type {BorrowerProcessDto}
     * @memberof BorrowerContractualizationResponse
     */
    process: BorrowerProcessDto;
    /**
     * Identifiant dossier partenaire (MNCAP ou Mutlog)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    idDossier: string;
    /**
     * Numéro assuré chez le partenaire
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    numeroAssure: string;
    /**
     * Code du partenaire (MNCAP ou MUTLOG)
     * @type {string}
     * @memberof BorrowerContractualizationResponse
     */
    partnerCode: string;
    /**
     * 
     * @type {BorrowerCardStatuses}
     * @memberof BorrowerContractualizationResponse
     */
    cardStatuses: BorrowerCardStatuses;
    /**
     * 
     * @type {BorrowerPermissions}
     * @memberof BorrowerContractualizationResponse
     */
    permissions: BorrowerPermissions;
    /**
     * 
     * @type {BorrowerDisabledReasons}
     * @memberof BorrowerContractualizationResponse
     */
    disabledReasons?: BorrowerDisabledReasons;
}


/**
 * @export
 */
export const BorrowerContractualizationResponseStatusCategoryEnum = {
    Draft: 'Draft',
    Accepted: 'Accepted',
    Cancelled: 'Cancelled'
} as const;
export type BorrowerContractualizationResponseStatusCategoryEnum = typeof BorrowerContractualizationResponseStatusCategoryEnum[keyof typeof BorrowerContractualizationResponseStatusCategoryEnum];

/**
 * @export
 */
export const BorrowerContractualizationResponseStatusSeverityEnum = {
    Critical: 'Critical',
    Warning: 'Warning',
    Success: 'Success',
    Neutral: 'Neutral'
} as const;
export type BorrowerContractualizationResponseStatusSeverityEnum = typeof BorrowerContractualizationResponseStatusSeverityEnum[keyof typeof BorrowerContractualizationResponseStatusSeverityEnum];

/**
 * @export
 */
export const BorrowerContractualizationResponseContractSignatureStatusEnum = {
    ToSign: 'ToSign',
    WaitingSignature: 'WaitingSignature',
    Signed: 'Signed'
} as const;
export type BorrowerContractualizationResponseContractSignatureStatusEnum = typeof BorrowerContractualizationResponseContractSignatureStatusEnum[keyof typeof BorrowerContractualizationResponseContractSignatureStatusEnum];


/**
 * Check if a given object implements the BorrowerContractualizationResponse interface.
 */
export function instanceOfBorrowerContractualizationResponse(value: object): value is BorrowerContractualizationResponse {
    if (!('quoteId' in value) || value['quoteId'] === undefined) return false;
    if (!('tunnelId' in value) || value['tunnelId'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('borrowerNumber' in value) || value['borrowerNumber'] === undefined) return false;
    if (!('isCompletedRiskInformation' in value) || value['isCompletedRiskInformation'] === undefined) return false;
    if (!('statusCode' in value) || value['statusCode'] === undefined) return false;
    if (!('statusCategory' in value) || value['statusCategory'] === undefined) return false;
    if (!('statusSeverity' in value) || value['statusSeverity'] === undefined) return false;
    if (!('contractSignatureStatus' in value) || value['contractSignatureStatus'] === undefined) return false;
    if (!('isContractStepStarted' in value) || value['isContractStepStarted'] === undefined) return false;
    if (!('isCasLemoine' in value) || value['isCasLemoine'] === undefined) return false;
    if (!('isMandateSigned' in value) || value['isMandateSigned'] === undefined) return false;
    if (!('isMaster' in value) || value['isMaster'] === undefined) return false;
    if (!('isAnimationCompleted' in value) || value['isAnimationCompleted'] === undefined) return false;
    if (!('isContractSend' in value) || value['isContractSend'] === undefined) return false;
    if (!('hasCertificate' in value) || value['hasCertificate'] === undefined) return false;
    if (!('isConditionsComplete' in value) || value['isConditionsComplete'] === undefined) return false;
    if (!('productOwner' in value) || value['productOwner'] === undefined) return false;
    if (!('pricingLoans' in value) || value['pricingLoans'] === undefined) return false;
    if (!('quoteTabs' in value) || value['quoteTabs'] === undefined) return false;
    if (!('medicalDocuments' in value) || value['medicalDocuments'] === undefined) return false;
    if (!('process' in value) || value['process'] === undefined) return false;
    if (!('idDossier' in value) || value['idDossier'] === undefined) return false;
    if (!('numeroAssure' in value) || value['numeroAssure'] === undefined) return false;
    if (!('partnerCode' in value) || value['partnerCode'] === undefined) return false;
    if (!('cardStatuses' in value) || value['cardStatuses'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function BorrowerContractualizationResponseFromJSON(json: any): BorrowerContractualizationResponse {
    return BorrowerContractualizationResponseFromJSONTyped(json, false);
}

export function BorrowerContractualizationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BorrowerContractualizationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'type': json['type'] == null ? undefined : json['type'],
        'quoteId': json['quoteId'],
        'tunnelId': json['tunnelId'],
        'folderIdentifier': json['folderIdentifier'] == null ? undefined : json['folderIdentifier'],
        'insured': ContractInsuredFromJSON(json['insured']),
        'borrowerNumber': json['borrowerNumber'],
        'isCompletedRiskInformation': json['isCompletedRiskInformation'],
        'statusCode': json['statusCode'],
        'statusCategory': json['statusCategory'],
        'statusSeverity': json['statusSeverity'],
        'contractSignatureStatus': json['contractSignatureStatus'],
        'isContractStepStarted': json['isContractStepStarted'],
        'isCasLemoine': json['isCasLemoine'],
        'isMandateSigned': json['isMandateSigned'],
        'isMaster': json['isMaster'],
        'isAnimationCompleted': json['isAnimationCompleted'],
        'isContractSend': json['isContractSend'],
        'hasCertificate': json['hasCertificate'],
        'isConditionsComplete': json['isConditionsComplete'],
        'isRealEstateComplete': json['isRealEstateComplete'] == null ? undefined : json['isRealEstateComplete'],
        'projectTypeCode': json['projectTypeCode'] == null ? undefined : json['projectTypeCode'],
        'expectedEffectiveDate': json['expectedEffectiveDate'] == null ? undefined : (new Date(json['expectedEffectiveDate'])),
        'realEstateId': json['realEstateId'] == null ? undefined : json['realEstateId'],
        'productOwner': json['productOwner'],
        'pricing': json['pricing'] == null ? undefined : BorrowerContractualizationPricingDtoFromJSON(json['pricing']),
        'pricingLoans': ((json['pricingLoans'] as Array<any>).map(BorrowerPricingWithGuaranteeDtoFromJSON)),
        'quoteTabs': ((json['quoteTabs'] as Array<any>).map(BorrowerQuoteTabDtoFromJSON)),
        'medicalGridCode': json['medicalGridCode'] == null ? undefined : json['medicalGridCode'],
        'medicalDocuments': json['medicalDocuments'],
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(BorrowerDocumentDtoFromJSON)),
        'process': BorrowerProcessDtoFromJSON(json['process']),
        'idDossier': json['idDossier'],
        'numeroAssure': json['numeroAssure'],
        'partnerCode': json['partnerCode'],
        'cardStatuses': BorrowerCardStatusesFromJSON(json['cardStatuses']),
        'permissions': BorrowerPermissionsFromJSON(json['permissions']),
        'disabledReasons': json['disabledReasons'] == null ? undefined : BorrowerDisabledReasonsFromJSON(json['disabledReasons']),
    };
}

export function BorrowerContractualizationResponseToJSON(json: any): BorrowerContractualizationResponse {
    return BorrowerContractualizationResponseToJSONTyped(json, false);
}

export function BorrowerContractualizationResponseToJSONTyped(value?: BorrowerContractualizationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'type': value['type'],
        'quoteId': value['quoteId'],
        'tunnelId': value['tunnelId'],
        'folderIdentifier': value['folderIdentifier'],
        'insured': ContractInsuredToJSON(value['insured']),
        'borrowerNumber': value['borrowerNumber'],
        'isCompletedRiskInformation': value['isCompletedRiskInformation'],
        'statusCode': value['statusCode'],
        'statusCategory': value['statusCategory'],
        'statusSeverity': value['statusSeverity'],
        'contractSignatureStatus': value['contractSignatureStatus'],
        'isContractStepStarted': value['isContractStepStarted'],
        'isCasLemoine': value['isCasLemoine'],
        'isMandateSigned': value['isMandateSigned'],
        'isMaster': value['isMaster'],
        'isAnimationCompleted': value['isAnimationCompleted'],
        'isContractSend': value['isContractSend'],
        'hasCertificate': value['hasCertificate'],
        'isConditionsComplete': value['isConditionsComplete'],
        'isRealEstateComplete': value['isRealEstateComplete'],
        'projectTypeCode': value['projectTypeCode'],
        'expectedEffectiveDate': value['expectedEffectiveDate'] == null ? undefined : ((value['expectedEffectiveDate'] as any).toISOString()),
        'realEstateId': value['realEstateId'],
        'productOwner': value['productOwner'],
        'pricing': BorrowerContractualizationPricingDtoToJSON(value['pricing']),
        'pricingLoans': ((value['pricingLoans'] as Array<any>).map(BorrowerPricingWithGuaranteeDtoToJSON)),
        'quoteTabs': ((value['quoteTabs'] as Array<any>).map(BorrowerQuoteTabDtoToJSON)),
        'medicalGridCode': value['medicalGridCode'],
        'medicalDocuments': value['medicalDocuments'],
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(BorrowerDocumentDtoToJSON)),
        'process': BorrowerProcessDtoToJSON(value['process']),
        'idDossier': value['idDossier'],
        'numeroAssure': value['numeroAssure'],
        'partnerCode': value['partnerCode'],
        'cardStatuses': BorrowerCardStatusesToJSON(value['cardStatuses']),
        'permissions': BorrowerPermissionsToJSON(value['permissions']),
        'disabledReasons': BorrowerDisabledReasonsToJSON(value['disabledReasons']),
    };
}

